module.exports = __webpack_public_path__ + "img/pay-quan.76003828.png";